import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchComments } from "./api"

export function useFetchComments(commentableType: string, commentableId: string) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["comments", commentableType, commentableId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")

      return fetchComments(context, commentableType, commentableId)
    },
  })
}
